export default {
  GET_CLAIM_LIST: '/auth/claim/searchByFirstLetter',
  GET_CATEGORY: '/auth/public/get_goodsMarketCategory',
  GET_TOP5_CLAIM: '/auth/brand/productClaim',
  GET_PRODUCT_CATEGORY: '/auth/brand/productCategory',
  GET_BRAND_LIST: '/auth/brand/list',
  GET_BRAND_SELECT: '/auth/brand/select',
  GET_CATEGORY_CLAIM: '/auth/brand/categoryAndClaim',
  EXPORT_LIST: '/auth/brand/exportList',
  GET_DETAIL_MARKET: '/auth/brand/detailMarket',
  GET_DETAIL_SHARE: '/auth/brand/detailShare',
  GET_CLICK_DATA: '/auth/brand/basicDataClick',
  GET_COMMENT_DATA: '/auth/brand/basicDataComment',
  GET_PRODUCT_CLAIM: '/auth/brand/productAndClaim',
  GET_NEW_PRODUCT: '/auth/brand/newProduct',
  GET_PRODUCT_DISTR: '/auth/brand/productsDistribution',
  GET_TOP10_PRODUCT: '/auth/brand/caregoryProduct',
  GET_FUNCTION: '/auth/brand/inciFounction',
  GET_TREND: '/auth/brand/inciUsing',
  GET_ANNUAL_DATA: '/auth/brand/annualData',
  GET_CONSUMER_ANN: '/auth/brand/annualDataConsumer',
  GET_BRAND_GROUP: '/auth/brand/groupAndBrand',
  GET_COUNTRY: '/auth/market/countryList',
  GET_BRAND_YEAR_LIST: '/auth/market/yearList',
  GET_POSITION_MAP: '/auth/brand/positionMap',
  GET_GROUP_lIST: '/auth/brand/selectGroup',
  GET_SUB_CATEGORY: '/auth/public/get_goodsSubCategory',
  GET_AREA_DETAIL: '/auth/brand/areaToProvince',
  getSegmentList: '/auth/market/segmentList',
  GET_BRAND_DETAIL: '/auth/brand/detail',
  GET_EXPORT_COUNT: '/auth/brand/getCount',
  GET_BRAND_SUGGESTED: '/auth/brand/suggested',
  getUpdateItem: '/auth/brand/lastUpdateTime',
  GET_ORIGIN_LIST: '/auth/brand/countryCodes',
  GET_AGE_DATA: '/auth/brand/annualAgeConsumer',
  GET_RELATED_BASF_PRODUCTS: '/auth/brand/inci/relateBasfProducts',
  GET_CONSUMER_CLICK_DATA: '/auth/brand/annual/consumerClicks',
  GET_CONSUMER_COMMENT_DATA: '/auth/brand/annual/consumerComments',
  GET_COMMENT_PROVINCES_DATA: '/auth/brand/annual/commentProvinces',
  GET_COUNTRY_NAMES: '/auth/brand/countryNames'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/brandAnalytics.js